
// Product Zoom js
$(document).ready(function () {
    const zoomBox = $('.ib-prod-zoom-box');

    const setBackgroundImage = (src) => {
        zoomBox.css('background-image', `url(${src})`);
    };

    const updateBackgroundPosition = (event) => {
        const { offsetX, offsetY, target } = event;
        const { offsetWidth: width, offsetHeight: height } = target;

        const xPos = (offsetX / width) * 100;
        const yPos = (offsetY / height) * 100;

        zoomBox.css('background-position', `${xPos}% ${yPos}%`);
    };

    const clearBackgroundImage = () => {
        zoomBox.css('background-image', '');
        zoomBox.css('background-position', '');
    };

    $('.ib-prod-gallery-main').on({
        mouseenter: function (event) {
            const img = $(this).find('.product__media img');
            setBackgroundImage(img.attr('src'));
            zoomBox.css('display', 'block');
        },
        mousemove: function (event) {
            updateBackgroundPosition(event);
        },
        mouseleave: function () {
            clearBackgroundImage();
            zoomBox.css('display', 'none');
        }
    }, 'li.is-active');
});